import React from 'react'
import { Card } from 'react-bootstrap'

const ProjectPreviewPanel = (props) => {
  if (!props.details) {
    return null
  }

  return (
    <Card.Text className={props.shade ? 'subfont text-light' : 'subfont text-dark'}>
      {props.details}
    </Card.Text>
  )
}

export default ProjectPreviewPanel